const guid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const randomStr = (length = 10) => {
  const text = [];
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  for (let i = 0; i < length; i++)
    text.push(possible.charAt(Math.floor(Math.random() * possible.length)));

  return text.join('');
};

const getURLParam = name => {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || ['', ''])[1].replace(/\+/g, '%20')) || '';
};

const round = (value, decimals) => {
  return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
};

const isTouch = () => {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
};

const formatMoney = (value, decimals = 0) => {
  value = parseFloat(value);

  if (value === null || value === undefined || isNaN(value)) {
    return '';
  }

  const fixed_value = value.toFixed(decimals);

  const decimal = decimals !== 0
    ? `,${ fixed_value.slice(-decimals) }`
    : '';

  const formatted_value = (Math.abs(Math.trunc(fixed_value))+'.')
    .replace(/(\d)(?=(\d{3})+\.)/g, '$1.')
    .slice(0, -1) + decimal;

  return value >= 0
    ? formatted_value
    : `-${ formatted_value}`;
};

const formatPercent = (value, decimals = 0) => {
  value = parseFloat(value);

  if (value === null || value === undefined || isNaN(value)) {
    return '';
  }

  const fixed_value = value.toFixed(decimals);

  const decimal = decimals !== 0
    ? `,${ fixed_value.slice(-decimals) }`
    : '';

  const formatted_value = (Math.abs(Math.trunc(fixed_value))+'.')
    .replace(/(\d)(?=(\d{3})+\.)/g, '$1.')
    .slice(0, -1) + decimal;

  return value >= 0
    ? formatted_value
    : `-${ formatted_value}`;
};

const closestParent = (element, selector) => {
  const ep = Element.prototype;
  ep.matches = ep.matches || ep.webkitMatchesSelector || ep.msMatchesSelector || ep.mozMatchesSelector;

  while (element && element !== document.body) {
    element = element.parentElement;
    if (element && element.matches(selector)) return element;
  }
};

const getTextWidthInPixels = (text, font) => {
  const canvas = getTextWidthInPixels.canvas || (getTextWidthInPixels.canvas = document.createElement('canvas'));
  const context = canvas.getContext('2d');
  context.font = font;
  const metrics = context.measureText(text);
  return metrics.width;
};

function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
    return String.fromCharCode(parseInt(p1, 16));
  }));
}

function b64DecodeUnicode(str) {
  return decodeURIComponent(Array.prototype.map.call(atob(str), function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
}

export {
  randomStr,
  guid,
  getURLParam,
  round,
  isTouch,
  closestParent,
  getTextWidthInPixels,
  formatMoney,
  formatPercent,
  b64EncodeUnicode,
  b64DecodeUnicode
};



// WEBPACK FOOTER //
// ./src/modules/utils.js